import * as React from 'react'
import autobind from 'autobind-decorator'
import { Typography, Icon, Tooltip, Grid } from '@material-ui/core'
import { summaryFrame } from 'src/shared/Cotation/summary/SummaryParams'
import { MediaCard } from 'src/shared/MediaCard/MediaCard'
import { formatDate } from 'src/core/i18n/date'
import {isEmpty} from 'lodash'
import { formatCurrency, isValidDate } from 'src/shared/utils/helpers'
import { WithI18n, withI18n } from 'src/core/i18n/withI18n'

interface IProps extends WithI18n{
    formParams: any;
    productType: string;
    firstLabel: string;
    secondLabel?: string;
    showSaleValue: boolean;
}

interface ISummary {
    first: any;
    second: any;
    sale: any;
}

interface IState {
    summary: ISummary | undefined;
}

class SummaryContext extends React.Component<IProps, IState> {
    state = {
        summary: {} as ISummary,
    }

    render() {
        const {firstLabel, secondLabel, showSaleValue} = this.props;
        const {summary} = this.state
        return (
            <>
                {!isEmpty(summary) &&
                    <>
                        <MediaCard icon="settings">
                            <Typography variant="body1" gutterBottom>{firstLabel}</Typography>
                            <br/>
                            <Grid container>
                                <Grid item xs={12} md={6}>
                                    {this.dataRender(summary.first)}
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    {this.dataRender(summary.second)}
                                </Grid>
                            </Grid>
                        </MediaCard>

                        <br /><br />

                        {showSaleValue && summary.sale.length > 0 &&
                            <MediaCard icon="monetization_on">
                                <Typography variant="body1" gutterBottom>{secondLabel}</Typography>
                                <br/>
                                <Grid container>
                                    <Grid item xs={12}>
                                        {this.dataRender(summary.sale)}
                                    </Grid>
                                </Grid>
                            </MediaCard>
                        }
                    </>
                }
            </>
        )
    }

    @autobind
    private dataRender(data: any){
        const {formParams} = this.props;
        return data ? data.map(d => (
            <>
                {this.shouldShowField(formParams, d) && 
                    <Typography gutterBottom key={d.value}>
                        <span style={{fontWeight: 'bold'}}>
                            {d.label}
                            {d.description &&
                                <Tooltip title={d.description} placement="top">
                                    <Icon style={{fontSize: '18px', color: '#9e9e9e', margin: '0 4px'}}>info</Icon>
                                </Tooltip>
                            }
                            <span style={{margin: '0 3px'}}>:</span>
                        </span>
                        {!Array.isArray(d.value) && this.formatField(formParams[d.value], d.type, d.fontStyle)}
                        {Array.isArray(d.value) && this.renderGroupValue(d) }
                        {d.after && formParams[d.value] !== undefined &&
                            <span style={{margin: '0 3px'}}>{d.after}</span>
                        }
                    </Typography>
                }
            </>
        )) : ''
    }

    @autobind
    private renderGroupValue(field){
        const {formParams} = this.props;
        const valueLabels = [];
        field.value.map(v => valueLabels.push(this.formatField(formParams[v], field.type, field.fontStyle)))
        return valueLabels.join(" - ")
    }

    @autobind
    private shouldShowField(form: any, data: any){
        return data.displayCondition ? data.displayCondition(form) : true
    }

    @autobind
    private formatField(field: any, fieldType: string, fontStyle: any){
        const {t} = this.props;
        if(field !== undefined && field !== null){
            switch(fieldType){
                case 'currency':
                    return formatCurrency(field)
                case 'date':
                    return isValidDate(field) ? formatDate(new Date(field)) : '-'
                case 'document':
                    return (
                        <a href={field} target="_blank" style={{marginLeft: '3px'}}>
                            <Icon style={{color: '#00c616'}}>insert_drive_file</Icon>
                        </a>
                    )
                case 'boolean':
                    return field ? t.yes : t.no;
                default: 
                    return <span style={{fontStyle: `${fontStyle ? fontStyle: 'normal'}`}}>{field}</span>
            }
        } else {
            return ' - '
        }
    }

    componentDidMount(){
        const {formParams, productType} = this.props;
        this.setState({summary: summaryFrame(formParams, productType) as ISummary})
    }

    componentDidUpdate(prevPros){
        const {formParams, productType} = this.props
        if(prevPros.formParams !== formParams && formParams){
            this.setState({summary: summaryFrame(formParams, productType) as ISummary})
        }
    }
}

export default withI18n(SummaryContext) 



// WEBPACK FOOTER //
// ./src/shared/Cotation/summary/SummaryContext.tsx